// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Golos+Text:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Golos Text", serif;
}

body,
#root {
  height: var(--app-height);
  width: 100vw;
  margin: 0;
  overflow-x: hidden;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #000000;
}

strong {
  font-weight: 600;
}

::-webkit-scrollbar {
  width: 0.375rem;
  height: 0.375rem;
  background-color: #F3F3F3;
}

::-webkit-scrollbar-thumb {
  border-radius: 0.75rem;
  background-color: #9D87F1;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #9D87F1;
}

::-webkit-scrollbar-thumb:active {
  background-color: #9D87F1;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}

.horizontalBarChartTooltipFlex {
  z-index: 11;
}

.horizontalBarChartTooltipContainer {
  background-color: rgba(255, 255, 255, 1) !important;
  color: rgba(0, 0, 0, 1) !important;
  padding: 1.25rem !important;
}

@media screen and (max-width: 1280px) {
  .horizontalBarChartTooltipContainer {
    padding: 1rem !important;
  }

  .barChartTooltip {
    padding: 1rem !important;
  }
}

.horizontalBarChartTooltipContainer::before {
  border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;
}

.horizontalBarChartTooltipName {
  margin-right: 1rem !important;
}

.barChartMouseTooltip {
  z-index: 999 !important;
}

.barChartTooltip {
  background-color: rgba(255, 255, 255, 1) !important;
  color: rgba(0, 0, 0, 1) !important;
  padding: 1.25rem !important;
}

.barChartTooltip::before {
  border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/main.css"],"names":[],"mappings":"AAGA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mFAAmF;AACrF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Golos+Text:wght@400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700&display=swap\");\n\n* {\n  font-family: \"Golos Text\", serif;\n}\n\nbody,\n#root {\n  height: var(--app-height);\n  width: 100vw;\n  margin: 0;\n  overflow-x: hidden;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: #000000;\n}\n\nstrong {\n  font-weight: 600;\n}\n\n::-webkit-scrollbar {\n  width: 0.375rem;\n  height: 0.375rem;\n  background-color: #F3F3F3;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 0.75rem;\n  background-color: #9D87F1;\n  background-clip: content-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #9D87F1;\n}\n\n::-webkit-scrollbar-thumb:active {\n  background-color: #9D87F1;\n}\n\n::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n.horizontalBarChartTooltipFlex {\n  z-index: 11;\n}\n\n.horizontalBarChartTooltipContainer {\n  background-color: rgba(255, 255, 255, 1) !important;\n  color: rgba(0, 0, 0, 1) !important;\n  padding: 1.25rem !important;\n}\n\n@media screen and (max-width: 1280px) {\n  .horizontalBarChartTooltipContainer {\n    padding: 1rem !important;\n  }\n\n  .barChartTooltip {\n    padding: 1rem !important;\n  }\n}\n\n.horizontalBarChartTooltipContainer::before {\n  border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;\n}\n\n.horizontalBarChartTooltipName {\n  margin-right: 1rem !important;\n}\n\n.barChartMouseTooltip {\n  z-index: 999 !important;\n}\n\n.barChartTooltip {\n  background-color: rgba(255, 255, 255, 1) !important;\n  color: rgba(0, 0, 0, 1) !important;\n  padding: 1.25rem !important;\n}\n\n.barChartTooltip::before {\n  border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
